import React from 'react';

import { FunnelItem } from './funnel-item';

export type FunnelItemsProps = {
  statName: string;
  statValue: number;
  tooltip?: string;
};

export function FunnelItems({ items }: { items: FunnelItemsProps[] }) {
  const highestValue = Math.max(1, ...items.map((item) => item.statValue));
  return (
    <>
      {items.map((item, index) => (
        <FunnelItem
          first={index === 0}
          id={item.statName}
          key={item.statName}
          last={index === items.length - 1}
          nextPercentage={index < items.length - 1 ? (items[index + 1].statValue / highestValue) * 100 : 0}
          percentage={(item.statValue / highestValue) * 100}
          prevPercentage={index > 0 ? (items[index - 1].statValue / highestValue) * 100 : 0}
          stat={item.statValue}
          title={item.statName}
          tooltip={item.tooltip}
        />
      ))}
    </>
  );
}
